// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XU2ljdCo5v4VBY .SKn-1TIquQQnXm,\n.XU2ljdCo5v4VBY .xzz3NhwFf9XkG8:hover {\n  color: var(--ds-icon-accent-yellow, #F2D600);\n}\n.XU2ljdCo5v4VBY .xzz3NhwFf9XkG8:active {\n  color: var(--ds-surface, #FFFFFF);\n}\n.XU2ljdCo5v4VBY .sAolAIZnoDyRzq:hover,\n.XU2ljdCo5v4VBY:focus > .sAolAIZnoDyRzq {\n  cursor: pointer;\n  transform: scale(1.2);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardStarButton": "XU2ljdCo5v4VBY",
	"starred": "SKn-1TIquQQnXm",
	"unstarred": "xzz3NhwFf9XkG8",
	"icon": "sAolAIZnoDyRzq"
};
export default ___CSS_LOADER_EXPORT___;
